import styled from "@emotion/styled";

export const StyledMeetingRoom = styled.main`
  height: 100dvh;
  .lk-prejoin {
    width: 100dvw;
    height: 100dvh;
    max-width: 1000px;
    justify-content: center;

    .lk-button-group {
      height: 44px;
    }
  }

  .lk-prejoin .lk-join-button {
    background: var(--primary) !important;
  }
`;
